import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

/**
 * @param {Object} props Component props
 * @param {boolean} props.open Whether the dialog is open
 * @param {function} props.onClose Function to call when the dialog is closed
 * @param {string} props.title The dialog title
 * @param {string} props.message The dialog message
 * @param {string} props.confirmText Text for the confirm button
 * @param {string} props.cancelText Text for the cancel button
 * @param {function} props.onConfirm Function to call when the user confirms
 * @param {string} props.confirmButtonColor MUI color for the confirm button (error, primary, etc.)
 */
const ConfirmationDialog = ({ open, onClose, title, message, confirmText = "Confirm", cancelText = "Cancel", onConfirm, confirmButtonColor = "primary" }) => {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleCancel} aria-labelledby="confirmation-dialog-title" aria-describedby="confirmation-dialog-description">
      <DialogTitle id="confirmation-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="confirmation-dialog-description">{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} color="inherit">
          {cancelText}
        </Button>
        <Button onClick={handleConfirm} color={confirmButtonColor} variant="contained" autoFocus>
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
